module.exports = __webpack_public_path__ + "static/media/question.4449c71b.svg";